import { Snackbar } from "@mui/material";
import mapboxgl, { Map, Marker } from "mapbox-gl";
import { useEffect, useRef, useState } from "react";
import { Loader } from "../../component/Loader";
import { defaultLat, defaultLng } from "../../helper/helper";
import PickupMarker from "../../rsc/pickup.svg";
import MapBox from "../MapBox";
import { PagePickUp } from "../PagePickUp";

type Props = {
    onPickupSelected: (coord: any) => void
    page: string
}

export function StepChoosePickup({ onPickupSelected, page }: Props) {

    const mapRef = useRef<Map | undefined>(undefined)

    const [error, setError] = useState<string | undefined>(undefined)

    const pickupPos = useRef<any | undefined>(undefined)

    const userPos = useRef<any | undefined>(undefined)

    const markerRef = useRef<Marker | undefined>(undefined)

    const [askPosLoader, setAskPosLoader] = useState<boolean>(false)

    useEffect(() => {
        window.gtag("event", "page_view", { page_path: page });
        // eslint-disable-next-line
    }, [])

    function onLoaded(map: Map) {
        mapRef.current = map
        askForPosition(() => {
            addPickUpMarker()
        }, () => {
            addPickUpMarker()
        })
    }

    function getPickupPos() {
        return pickupPos.current ?? { lng: userPos?.current?.longitude ?? defaultLng, lat: userPos?.current?.latitude ?? defaultLat }
    }

    function addPickUpMarker() {
        const customMarker = document.createElement('div');
        const markerImg = document.createElement('img');
        markerImg.src = PickupMarker;
        markerImg.style.width = "170px"
        markerImg.style.width = "85px"

        // Append the image to the custom marker
        customMarker.appendChild(markerImg);
        customMarker.style.zIndex = "8"
        pickupPos.current = getPickupPos()
        const marker = new mapboxgl.Marker({
            element: customMarker,
            draggable: true,
            anchor: 'bottom'
        })
            .setLngLat([pickupPos.current.lng, pickupPos.current.lat])
            .addTo(mapRef.current!);

        marker.on('dragend', () => {
            const lngLat = marker.getLngLat();
            pickupPos.current = { lng: lngLat.lng, lat: lngLat.lat }
        });
        markerRef.current = marker
    }

    function askForPosition(onSuccess?: () => void, onError?: () => void) {
        if (!navigator.geolocation) {
            setError('Geolocation is not supported by this browser.');
        } else if (mapRef.current) {
            setAskPosLoader(true)
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setAskPosLoader(false)
                    const { latitude, longitude } = position.coords;
                    userPos.current = { latitude, longitude }
                    const pickupPos = getPickupPos()
                    const control = new mapboxgl.GeolocateControl({
                        positionOptions: { enableHighAccuracy: true },
                        trackUserLocation: true,
                        showUserLocation: true,
                        showAccuracyCircle: false,
                        fitBoundsOptions: { center: [pickupPos.lng, pickupPos.lat], zoom: mapRef.current?.getZoom() }
                    })
                    control.on('error', (e: any) => {
                        console.log('controle failure', error)
                    })
                    control.on('geolocate', (e: any) => {
                        console.log('controle success', error)
                    })
                    if (mapRef.current?.hasControl(control) === false) {
                        mapRef.current?.addControl(control);
                        setTimeout(() => {
                            control.trigger()
                        }, 1000)
                    }
                    onSuccess?.()
                },
                (err) => {
                    setError(err.message);
                    setAskPosLoader(false)
                    onError?.()
                }
                , {
                    timeout: 7000
                });
        }
    }

    return (
        <div style={{ flex: 1, position: "relative", display:"flex", flexDirection:"column" }}>
            <MapBox style={{ width: "100%", flex:1, display:"flex", flexDirection:"column" }} onLoaded={onLoaded} />
            <PagePickUp fetchNafPrice={() => onPickupSelected(pickupPos.current)} page="landingpage2_price_mill_selected" />
            {
                error ?
                    <Snackbar
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "center"
                        }}
                        open={error !== undefined}
                        autoHideDuration={6000}
                        onClose={() => { setError(undefined) }}
                        message={error}
                        sx={{
                            '& .MuiSnackbarContent-root': {
                                backgroundColor: "#f00",
                                fontWeight: "600"
                            }
                        }}
                    /> : <></>
            }
            <Loader isLoading={askPosLoader} />
        </div>
    )
}